;globalThis["_sentryRewritesTunnelPath"] = "/sentry/monitoring-tunnel";globalThis["SENTRY_RELEASE"] = {"id":"bbc33eee8e82830c0ed10760a67077ad6e1461a4"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN =
  process.env.SENTRY_DSN ||
  process.env.NEXT_PUBLIC_SENTRY_DSN ||
  'https://722a81bf37c743ed926a762be6cd1fc1@o409459.ingest.sentry.io/5774512';

Sentry.init({
  environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
  dsn: SENTRY_DSN,
  tracesSampleRate: 1.0,
});
